import styled from 'styled-components';

export const Perpetrators = styled.div`
  margin-top: 24px;
`;

export const PerpetratorList = styled.ul`
  padding-left: 0;
  display: flex;
  flex-wrap: wrap;
`;

export const DeleteButton = styled.button`
  background-color: inherit;
  border: none;
  &:hover {
    cursor: pointer;
  }
  padding: 0px;
  display: flex;
  align-items: center;
`;

export const PerpetratorName = styled.p`
  max-width: 500px;
  overflow-x: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  margin: 0 8px 0 0;
  font-size: 14px;
`;

export const PerpetratorPill = styled.li`
  display: flex;
  align-items: center;
  background-color: white;
  border-radius: 20px;
  margin-bottom: 8px;
  margin-right: 8px;
  padding: 8px;
  border: 1px solid
    ${(props) =>
      props.theme.isVaultVariant
        ? props.theme.newPalette.neutral.N400
        : props.theme.atlas.semantic.color.outline.default};
  font-family: ${(props) => props.theme.typography.fontFamily};
`;
